import { render, staticRenderFns } from "./QRComp.vue?vue&type=template&id=24df2632"
import script from "./QRComp.vue?vue&type=script&lang=js"
export * from "./QRComp.vue?vue&type=script&lang=js"
import style0 from "./QRComp.vue?vue&type=style&index=0&id=24df2632&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports